import { createFileRoute } from '@tanstack/react-router'
import { TierListTable } from '@/components/commission-tiers/tier-list-table'
import { ProgramListTable } from '@/components/creator-programs/program-list-table'
import { SectionCard } from '@/components/shared/section-card'
import { PageHeader } from '@/components/shared/page-header'

export const Route = createFileRoute('/_app/settings/creators')({
  component: SettingsCreatorsPage,
})

/**
 * Render the "Creators & Parceiros" settings page for configuring creators and partner rules.
 *
 * Renders a header with a title and description, and a card containing the "Tiers de Comissão"
 * section which displays the TierListTable for managing commission tiers and monthly seeding limits.
 *
 * @returns The React element representing the settings page.
 */
function SettingsCreatorsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        size="sm"
        title="Creators & Parceiros"
        description="Configure as regras do seu programa de creators e parcerias (Partner Portal)."
      />

      <div className="grid gap-6">
        <SectionCard
          title="Programas de Cupom"
          description="Define o desconto, garantia e regras de plataforma dos cupons dos creators. Cada creator é vinculado a um programa."
        >
          <ProgramListTable />
        </SectionCard>

        <SectionCard
          title="Tiers de Comissão"
          description="A estrutura hierárquica que define quanto cada nível de criador recebe de comissionamento sobre as vendas e quantos produtos ele pode receber mensalmente (Seedings)."
        >
          <TierListTable />
        </SectionCard>
      </div>
    </div>
  )
}
